import React from 'react'

const FaqTypeName = ({varInputFaqTypeName,setInputFaqTypeName,varCurrentFaqTypeIndex,varCurrentFaqTypeName,setCurrentFaqTypeName,onUpdateFaqTypeHandler}) => {
  const onChangeInputHandler = (e) => {
    const svalue = e.currentTarget.value;
    setCurrentFaqTypeName(svalue);
  }

  return !varInputFaqTypeName?null:(
    <div className={varInputFaqTypeName?"layer__pop open":"layer__pop"}>
      <div className="layer__pop__confirm" style={{maxWidth:"300px"}}>
        <div className="layer__bottom__head mb15">
          <div className="layer__pop__title" style={{paddingTop:"20px"}}>{varCurrentFaqTypeIndex===0?"추가등록":"수정하기"}</div>
          <div className="layer__pop__close" onClick={()=>setInputFaqTypeName(false)}></div>
        </div>
        <div className="layer__pop__body" style={{marginTop:"10px"}}> 
          <input type="text" style={{width:"100%"}} name="faqname" value={varCurrentFaqTypeName} onChange={e=>onChangeInputHandler(e)} />
        </div>
        <div className="btn-center" style={{display:"flex",justifyContent:"center"}}>
          <button onClick={()=>setInputFaqTypeName(false)} style={{width:"90px"}} className="btn line black">취소</button>
          <button onClick={e=>onUpdateFaqTypeHandler(e)} style={{width:"90px"}} className="btn line black">확인</button>
        </div>
      </div>
    </div>
  )
}
export default FaqTypeName;